import { Space } from "antd";
import { useEffect, useState } from "react";
import DefaultFormParserLayout from "../../../components/Layouts/default-form-parser-layout";
import Button from "../../../components/UI/Button";
import Input from "../../../components/UI/Input";
import { Output } from "../../../services/types";
import { useLoading } from "../../../context/LoadingProvider/useLoading";
import {
  GetUserListReportParams,
  getUserListReport,
} from "../../../services/reports";
import { IParams } from "../../../context/ListRecordProvider/types";
import endpoints from "../../../utils/endpoints";

type Form = {
  userSearch: string;
};

function UserList() {
  const loading = useLoading();

  const [params, setParams] = useState<IParams>({
    id: null,
    name: "",
  });

  const [form, setForm] = useState<Form>({
    userSearch: "",
  });

  const [report, setReport] = useState<string>("");

  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      refreshReport()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  const refreshReport = async (output: Output = Output.HTML) => {
    loading.addLoading();

    const getUserListReportParams: GetUserListReportParams =
      {
        output,
        userSearch: form.userSearch,
      };

    if (!!form.userSearch) {
      getUserListReportParams.userSearch = form.userSearch;
    }

    const res = await getUserListReport(
      getUserListReportParams
    );

    if (Output.isHTML(output)) {
      setReport(res);
    }

    loading.removeLoading();
  };

  return (
    <DefaultFormParserLayout html={report}>
      <Space direction="horizontal" size="small" wrap>
      <Input
          label="User Search"
          onChange={(e: any) => setForm({ ...form, userSearch: e.target.value })}
          value={form.userSearch}
        />
        
        <Button type="primary" onClick={() => refreshReport()}>
          Refresh
        </Button>

        <Button type="primary" onClick={() => refreshReport(Output.CSV)}>
          Save as CSV
        </Button>

        <Button type="primary" onClick={() => refreshReport(Output.PDF)}>
          Save as PDF
        </Button>
      </Space>
    </DefaultFormParserLayout>
  );
}

export default UserList;
